import managementPanel from './management-painel'

export default {
  successCases: {
    managementPanel,
  },
}
